import React from "react";
import {Card} from "tea-component";
import {useDblIntl} from "@/pages/datalab/utils/utils";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";


export default function () {
	const {dblFormatMessage: gptFormatMessage} = useDblIntl("gpt_home");
	
	return (<Card className={"dbl-gpt-home-faq"}>
		<Card.Body title={<div className={"dbl-title-16"}>{gptFormatMessage("faq")}</div>}>
			<ReactMarkdown
				children={gptFormatMessage("faq_content")}
				rehypePlugins={[rehypeRaw]}
			/>
		</Card.Body>
	</Card>)
}